import actions from '@/store/modules/dynamic-attributes/actions.js'
import cloneDeep from 'lodash/cloneDeep'
import state from '@/store/modules/dynamic-attributes/state.js'
import mutations from '@/store/modules/dynamic-attributes/mutations.js'
import getters from '@/store/modules/dynamic-attributes/getters.js'

export default {
  actions,
  state: cloneDeep(state),
  mutations,
  getters,
}
